type CredentialMailboxSource = {
  generatedMailboxAddress?: string | null;
  mfaConfig?: Array<{
    providerType?: string | null;
    emailAddress?: string | null;
    isActive?: boolean | null;
    enabled?: boolean;
  }> | null;
};

export const resolveCredentialMailboxAddress = (
  credential: CredentialMailboxSource,
): string => {
  const emailMfaAddress = (credential.mfaConfig ?? []).find(
    (config) =>
      config.providerType === 'EMAIL' &&
      Boolean(config.emailAddress) &&
      config.isActive !== false &&
      config.enabled !== false,
  )?.emailAddress;

  return emailMfaAddress ?? credential.generatedMailboxAddress ?? '';
};
